import { createVNode as _createVNode } from "vue";
import { defineComponent, provide } from "vue";
// components
import ChampionShow from "./components/championShow.vue";
import Information from "./components/information.vue";
import MatchProcess from "./components/matchProcess.vue";
import RaceInfo from "@/components/m/race-info.vue";
import Video from "./components/video.vue";
import { useHomePage } from "@/hooks/home-page";
// context
import { homePageContextKey } from "@/context/home-page";
export default defineComponent({
  name: "MHomePage",
  props: {
    // 是否是被其它组件引入
    referType: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    //hooks
    const {
      homePageState,
      raceQuarterSwitchFct,
      groupSwitchFct,
      raceTypeSwitchFct,
      // 积分赛模块
      integrationState,
      integRef
    } = useHomePage();
    provide(homePageContextKey, {
      homePageState,
      raceQuarterSwitchFct,
      groupSwitchFct,
      raceTypeSwitchFct,
      // 积分赛模块
      integrationState,
      integRef
    });
    return () => {
      return _createVNode("div", {
        "class": "homepage"
      }, [props.referType === "raceHonors" ? _createVNode("div", null, [_createVNode(ChampionShow, {
        "id": "honor-box"
      }, null)]) : _createVNode("div", null, [_createVNode(RaceInfo, {
        "referType": "homepage"
      }, null), _createVNode(MatchProcess, {
        "id": "match-box"
      }, null), _createVNode(Information, {
        "id": "info-box"
      }, null), _createVNode(Video, {
        "id": "video-box"
      }, null)])]);
      // if (props.referType === "raceHonorsShow") {
      //   return (
      //     <div>
      //       <ChampionShow id="honor-box" />
      //     </div>
      //   )
      // } else if (props.referType === "raceHonorsProcess") {
      //   return (
      //     <div>
      //       <MatchProcess id="match-box" />
      //     </div>
      //   )
      // } else {
      //   return (
      //     <div>
      //       <RaceInfo referType="homepage" />
      //       <MatchProcess v-show={false} id="match-box" />
      //       <Information v-show={false} id="info-box" />
      //       <Video id="video-box" />
      //     </div>
      //   )
      // }
    };
  }
});